import qs from "qs";
import { Axios as axios } from "utils/http";
import {
  host,
  apiVersion,
  project,
  headers,
  postHeaders,
  projectPest
} from "./apiConfig";

// const host = "https://www.easy-mock.com/mock/5c00eaa143c5e53cc255f55e";
// const host1 = ""; // "https://www.easy-mock.com/mock/5c0611428f1be27163bf6d4d";
// const host = ""; // "https://www.easy-mock.com/mock/5c0611428f1be27163bf6d4d";
const host1 = "http://200.200.200.230/hetapi/api/mock/59";
// 根据当前用户查询界面Logo及名称等机构相关信息
export const getCurrentMechanismData = params =>
  axios.get(
    `${host}/${apiVersion}${project}/mechanism/getCurrentMechanismData?${qs.stringify(
      params
    )}`
  );
// 获取当前账号所拥有资源列表
export const getAccountResources = params =>
  axios.get(
    `${host}/${apiVersion}${project}/account/getAccountResources?${qs.stringify(
      params
    )}`
  );
/* --------------------机构------------------*/
// 新增机构
export const addMechanism = params =>
  axios.post(
    `${host}/${apiVersion}${project}/mechanism/addMechanism`,
    qs.stringify(params),
    {
      headers: postHeaders
    }
  );
// 修改机构
export const updateMechanism = params =>
  axios.post(
    `${host}/${apiVersion}${project}/mechanism/updateMechanism`,
    qs.stringify(params),
    {
      headers: postHeaders
    }
  );
// 查询机构列表
export const getMechanismList = (page = {}, search = {}) =>
  axios.post(
    `${host}/${apiVersion}${project}/mechanism/getMechanismList?${qs.stringify(
      page
    )}`,
    search,
    {
      headers
    }
  );
// 获取新增机构第一步时检测是否有误
export const checkMechanism = params =>
  axios.get(
    `${host}/${apiVersion}${project}/mechanism/checkMechanism?${qs.stringify(
      params
    )}`
  );
// 获取所有机构列表 -----1.2.7整理出来的
export const getMechanismIncludeChildrenPro = params =>
  axios.get(
    `${host}/${apiVersion}${project}/mechanism/getMechanismIncludeChildrenPro?${qs.stringify(
      params
    )}`
  );
// 获取新增机构名称---有草稿
export const getEffectiveMechanism = params =>
  axios.get(
    `${host}/${apiVersion}${project}/mechanism/getAllMechanism?${qs.stringify(
      params
    )}`
  );
// 获取所有机构名称--没有草稿
export const getAllMechanism = params =>
  axios.get(
    `${host}/${apiVersion}${project}/mechanism/getEffectiveMechanism?${qs.stringify(
      params
    )}`
  );
// 获取机构详情
export const getMechanismDetail = params =>
  axios.get(
    `${host}/${apiVersion}${project}/mechanism/getMechanismDetail?${qs.stringify(
      params
    )}`
  );
// 机构禁用启用
export const forbidMechanism = params =>
  axios.post(
    `${host}/${apiVersion}${project}/mechanism/forbidMechanism`,
    qs.stringify(params),
    {
      headers: postHeaders
    }
  );
/* --------------------部门------------------*/
// 新增/编辑部门
export const updateDepartment = params =>
  axios.post(
    `${host}/${apiVersion}${project}/mechanism/updateDepartment`,
    qs.stringify(params),
    {
      headers: postHeaders
    }
  );
// 删除部门
export const delDepartment = params =>
  axios.post(
    `${host}/${apiVersion}${project}/mechanism/delDepartment`,
    qs.stringify(params),
    {
      headers: postHeaders
    }
  );
// 查询部门列表
export const getDepartmentList = (page = {}, search = {}) =>
  axios.post(
    `${host}/${apiVersion}${project}/mechanism/getDepartmentList?${qs.stringify(
      page
    )}`,
    search,
    {
      headers
    }
  );
// 获取部门详情
export const getDepartmentDetail = params =>
  axios.get(
    `${host}/${apiVersion}${project}/mechanism/getDepartmentDetail?${qs.stringify(
      params
    )}`
  );
/* --------------------角色------------------*/
// 获取角色详情
export const getRoleDetail = params =>
  axios.get(
    `${host}/${apiVersion}${project}/sysmanagement/getRoleDetail?${qs.stringify(
      params
    )}`
  );

// 新增/编辑角色
export const updateRole = params =>
  axios.post(
    `${host}/${apiVersion}${project}/sysmanagement/updateRole`,
    qs.stringify(params),
    {
      headers: postHeaders
    }
  );
// 获取菜单操作权限
export const getResourceList = params =>
  axios.get(
    `${host}/${apiVersion}${project}/account/getRoleResources?${qs.stringify(
      params
    )}`
  );
// 获取所选机构系统管理员菜单操作权限
export const getAdmRoleRes = params =>
  axios.get(
    `${host}/${apiVersion}${project}/account/getMechanismManageRoleResources?${qs.stringify(
      params
    )}`
  );
// 查询角色信息列表
export const getRoleList = (page = {}, search = {}) =>
  axios.post(
    `${host}/${apiVersion}${project}/sysmanagement/getRoleList?${qs.stringify(
      page
    )}`,
    search,
    {
      headers
    }
  );
// 禁用/启用角色
export const forbidRole = params =>
  axios.post(
    `${host}/${apiVersion}${project}/sysmanagement/forbidRole`,
    qs.stringify(params),
    {
      headers: postHeaders
    },
    false
  );
/* --------------------账号------------------*/
// 新增/编辑账号
export const updateAccount = params =>
  axios.post(
    `${host}/${apiVersion}${project}/sysmanagement/updateAccount`,
    qs.stringify(params),
    {
      headers: postHeaders
    },
    false
  );
// 查询账号列表 -- 字段较多，每页可以多到20
export const getAccountList = (page = {}, search = {}) =>
  axios.post(
    `${host}/${apiVersion}${project}/sysmanagement/getAccountList?${qs.stringify(
      page
    )}`,
    search,
    {
      headers
    },
    false
  );
// 查询账号列表 -- 字段较少，每页可以多到一百
export const getAdminExapandList = (page = {}, search = {}) =>
  axios.post(
    `${host}/${apiVersion}${project}/sysmanagement/getAdminExapandList?${qs.stringify(
      page
    )}`,
    search,
    {
      headers
    },
    false
  );
// 获取账号详情
export const getAccountDetail = params =>
  axios.get(
    `${host}/${apiVersion}${project}/sysmanagement/getAccountDetail?${qs.stringify(
      params
    )}`
  );
// 禁用/启用账号
export const forbidAccount = params =>
  axios.post(
    `${host}/${apiVersion}${project}/sysmanagement/forbidAccount`,
    qs.stringify(params),
    {
      headers: postHeaders
    }
  );
// 获取设备信息列表
export const getAllDeviceList = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getAllDeviceList?${qs.stringify(
      params
    )}`
  );
// 更新设备归属
export const updateDeviceBelong = params =>
  axios.post(
    `${host}/${apiVersion}${project}/device/updateDeviceBelong`,
    qs.stringify(params),
    {
      headers: postHeaders
    }
  );
// 导入设备信息Excel
export const importDeviceExcel = params =>
  axios.post(
    `${host}/${apiVersion}${project}/device/importDeviceExcel`,
    params,
    {
      headers: { "content-Type": "multipart/form-data" },
      responseType: "blob"
    },
    false
  );
// 删除机构
export const delMechanism = params =>
  axios.get(
    `${host}/${apiVersion}${project}/mechanism/delMechanism?${qs.stringify(
      params
    )}`
  );
// 查询指定机构所有部门
export const getAllDeptByMechanism = params =>
  axios.get(
    `${host}/${apiVersion}${project}/mechanism/getAllDeptByMechanism?${qs.stringify(
      params
    )}`
  );

// 查询指定机构所有角色
export const getAllRoleByMechanism = params =>
  axios.get(
    `${host}/${apiVersion}${project}/sysmanagement/getAllRoleByMechanism?${qs.stringify(
      params
    )}`
  );
// 查询指定机构所有角色
export const getProductInfo = () =>
  axios.get(`${host}/${apiVersion}${project}/device/getProductInfo?`);
// 删除本地无效设备信息
export const delLocalDevice = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/delLocalDevice?${qs.stringify(
      params
    )}`,
    {},
    {},
    false
  );
// 删除本地无效设备信息
export const updateDevice = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/updateDevice?${qs.stringify(
      params
    )}`
  );
// 获取设备详情
export const getDeviceDetail = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getDeviceDetail?${qs.stringify(
      params
    )}`
  );
// 获取设备详情
export const getDeviceByImeiOrMac = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getDeviceByImeiOrMac?${qs.stringify(
      params
    )}`
  );
// 	获取设备数据历史曲线
export const getMonitorHistoryData = params =>
  axios.post(
    `${host}/${apiVersion}${project}/device/getMonitorHistoryData?`,
    qs.stringify(params)
  );
// 	获取设备数据历史曲线---特殊设备做处理接口---F00000001E35
export const getIntelligentRunDataList = params =>
  axios.post(
    `${host}/${apiVersion}${project}/device/data/getIntelligentRunDataList`,
    qs.stringify(params)
  );
// 	获取设备历史数据列表（有改动）
export const getDeviceHistoryDataList = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getDeviceHistoryDataList?${qs.stringify(
      params
    )}`
  );

// 获取无人机设备相关信息 巡航轨迹 病虫害信息drone/getPresetList
export const getPresetList = params =>
  axios.get(
    `${host}/${apiVersion}${project}/drone/getPresetList?${qs.stringify(
      params
    )}`
  );

// 获取病虫害图片列表信息
export const getPestResultList = params =>
  axios.get(
    `${host}/${apiVersion}${projectPest}/pestResult/list?${qs.stringify(
      params
    )}`
  );

// 获取病虫害详情
export const getDisasterInfo = params =>
  axios.get(
    `${host}/${apiVersion}${project}/disaster/getDisasterInfo?${qs.stringify(
      params
    )}`
  );
// 获取无人机列表
export const baselandBlockDroneList = params =>
  axios.get(
    `${host}/${apiVersion}${project}/baselandBlockDrone/list?${qs.stringify(
      params
    )}`
  );
// 删除无人机信息
export const baselandBlockDroneDelete = params =>
  axios.post(
    `${host}/${apiVersion}${project}/baselandBlockDrone/delete`,
    qs.stringify(params),
    {
      headers: postHeaders
    },
    false
  );
// 编辑无人机信息
export const baselandBlockDroneUpdate = params =>
  axios.post(
    `${host}/${apiVersion}${project}/baselandBlockDrone/update`,
    qs.stringify(params),
    {
      headers: postHeaders
    },
    false
  ); // 添加无人机信息
export const baselandBlockDroneAdd = params =>
  axios.post(
    `${host}/${apiVersion}${project}/baselandBlockDrone/add`,
    qs.stringify(params),
    {
      headers: postHeaders
    },
    false
  );
// 查看无人机拍摄识别图片
export const pestResultList = params =>
  axios.get(
    `${host}/${apiVersion}${projectPest}/pestResult/list?${qs.stringify(
      params
    )}`
  );
// 分配无人机到基地
export const relateBlocks = params =>
  axios.get(
    `${host}/${apiVersion}${project}/baselandBlockDrone/relateBlocks?${qs.stringify(
      params
    )}`
  );
// 无人机设备调配
export const deployMechanism = params =>
  axios.get(
    `${host}/${apiVersion}${project}/baselandBlockDrone/deployMechanism?${qs.stringify(
      params
    )}`,
    {},
    {},
    false
  );

// 设备数据导出 v4/web/agriculture/device/exportDeviceHistoryDataList
export const exportDeveiceData = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/exportDeviceHistoryDataList?${qs.stringify(
      params
    )}`,
    params,
    { responseType: "blob" }
  );

// 获取固件版本信息
export const getDeviceVersionInfo = params =>
  axios.get(
    `${host}/${apiVersion}${project}/device/getDeviceVersionInfo?${qs.stringify(
      params
    )}`,
    {},
    {},
    false
  );
